import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPollSelected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 12C3 7.02944 7.02944 3 12 3C14.178 3 16.1753 3.77367 17.7321 5.06119L11.1887 14.2989L8.80278 11.0979L7.19922 12.2932L9.58516 15.4942C10.3971 16.5835 12.0355 16.5636 12.8208 15.455L19.145 6.52666C20.3085 8.04322 21 9.94085 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
		fill: "#0FAFAF"
	})
});
export default SvgPollSelected;
